import clsx from 'clsx';
import React from 'react';

const ArchivedItem = (props) => {
  const { filename, actionTypeLabel } = props;

  return (
    <React.Fragment>
      <span className={clsx('tw-text-cfo-black')}> {actionTypeLabel} </span>
      <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold !tw-font-normal')}>
        {filename}
      </strong>
    </React.Fragment>
  );
};

export default ArchivedItem;
